import styled from 'styled-components'
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import { useDispatch,useSelector } from 'react-redux'
import { accountFilter } from "../../../redux/actions/cuentasActions.js";

let Container=styled.div``;


export default function SearchInputsAccount(){
	let filtro=useSelector(state=>state.cuentas.account_filter);
	let dispatch=useDispatch();

 	let onWriteFilter=(e)=>{
    	let value = e.target.value;
    	dispatch(accountFilter(value));
  	}
	
	return(
		<Container>
			<Paper sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}>      
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder="Buscar..."       
        onChange={onWriteFilter}
        value={filtro}
      />
      <IconButton type="button" sx={{ p: '10px' }} >
        <SearchIcon />
      </IconButton>
      
    </Paper>
		</Container>
	)
}